import React, {ChangeEvent} from 'react';
import {makeStyles, Theme} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import Divider from '@material-ui/core/Divider';
import {useTheme} from '@material-ui/styles';

const width = 135;
const height = 42;

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        width,
        height,
        padding: 0,
        borderRadius: 0,
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: theme.palette.grey[300],
        'box-shadow': 'none',
        margin: 'auto',
    },
    input: {
        marginLeft: 8,
        flex: 1,
    },
    iconButton: {
        padding: 10,
        borderRadius: 0,
        height,
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.white,

        '&:hover': {
            backgroundColor: theme.palette.primary.light,
        },
        '&:active': {
            backgroundColor: theme.palette.primary.dark,
        },
    },
    divider: {},
}));

interface Props {
    value: number;
    min: number;
    max: number;
    disabled?: boolean;
    useInput?: boolean;
    onChange: (value: number) => void;
    decrement?: () => void;
    increment?: () => void;
}

export const NumberSpinner = (props: Props) => {
    const classes = useStyles();
    const theme = useTheme<Theme>();

    const displayInput = props.useInput === undefined ? true : props.useInput;

    const decrement = () => {
        if (props.decrement) {
            props.decrement();
        }
    };

    const increment = () => {
        if (props.increment) {
            props.increment();
        }
    };

    const newValue = (val: number) => {
        if (val >= props.min && val <= props.max) {
            props.onChange(val);
        }
    };

    return (
        <Paper className={classes.root}>
            <IconButton
                className={classes.iconButton}
                onClick={() => {
                    if (!displayInput) {
                        decrement();
                    }

                    newValue(props.value - 1);
                }}
                disabled={props.disabled}
            >
                <RemoveIcon/>
            </IconButton>

            {displayInput && (
                <React.Fragment>
                    <Divider color={theme.palette.grey[300]} className={classes.divider} orientation="vertical"/>
                    <InputBase
                        type="number"
                        className={classes.input}
                        inputProps={{
                            min: 0,
                            max: 100,
                        }}
                        value={props.value}
                        onChange={(event: ChangeEvent<HTMLTextAreaElement>) => {
                            props.onChange(Number(event.target.value));
                        }}
                        disabled={props.disabled}
                    />
                    <Divider color={theme.palette.grey[300]} className={classes.divider} orientation="vertical"/>
                </React.Fragment>
            )}

            {!displayInput && (
                <React.Fragment>
                    <Divider color={theme.palette.grey[300]} className={classes.divider} orientation="vertical"/>
                    <div style={{ width: 50 }} />
                    <Divider color={theme.palette.grey[300]} className={classes.divider} orientation="vertical"/>
                </React.Fragment>
            )}

            <IconButton
                className={classes.iconButton}
                onClick={() => {
                    if (!displayInput) {
                        increment();
                    }

                    newValue(props.value + 1);
                }}
                disabled={props.disabled}
            >
                <AddIcon/>
            </IconButton>
        </Paper>
    );
}

export default NumberSpinner;
